import Navigation from 'components/shared/Navigation/Navigation'
import config from 'config/config'
import React from 'react'
import { connect } from 'react-redux'
import { Grid } from 'semantic-ui-react'
import NPSScore from './NPSScore'

const mapStateToProps = (state, ownProps) => {
  const { badges } = state.navigation

  return { badges }
}

class DashboardTiles extends React.PureComponent {
  render() {
    const { badges } = this.props
    return (
      <Grid className="dashboardTiles noselect" columns={9} doubling>
        <Grid.Row>
          <Grid.Column>
            <NPSScore/>
          </Grid.Column>
          <Grid.Column>
            <Navigation
              render="link"
              as="card"
              node={config.nodes.dealer_orders}
              customProps={{ badge: badges && badges['dealer_orders'] }}
            />
          </Grid.Column>
          {/*
          <Grid.Column>
            <Navigation render='link' as='card' node={config.nodes.contactRequests}
                        customProps={{ badge: badges && badges['contact_requests'] }}/>
          </Grid.Column>
          */}
          <Grid.Column>
            <Navigation
              render="link"
              as="card"
              node={config.nodes.customer_orders}
              customProps={{ badge: badges && badges['customer_orders'] }}
            />
          </Grid.Column>
          <Grid.Column>
            <Navigation
              render="link"
              as="card"
              node={config.nodes.products}
              customProps={{ badge: badges && badges['products'] }}
            />
          </Grid.Column>
          <Grid.Column>
            <Navigation
              render="link"
              as="card"
              node={config.nodes.categories}
            />
          </Grid.Column>
          <Grid.Column>
            <Navigation
              render="link"
              as="card"
              node={config.nodes.properties}
            />
          </Grid.Column>
          <Grid.Column>
            <Navigation render="link" as="card" node={config.nodes.discounts} />
          </Grid.Column>
          <Grid.Column>
            <Navigation
              render="link"
              as="card"
              node={config.nodes.todos}
              customProps={{ badge: badges && badges['todo'] }}
            />
          </Grid.Column>
          <Grid.Column>
            <Navigation
              render="link"
              as="card"
              node={config.nodes.users}
              customProps={{ badge: badges && badges['dealers'] + badges['unverified_bops'] }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

DashboardTiles = connect(mapStateToProps)(DashboardTiles)
export default DashboardTiles



// WEBPACK FOOTER //
// ./src/components/admin/Helper/DashboardTiles.jsx